import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-brand-navy border-t-4 border-brand-orange py-12 px-5" data-id="element-122">
      <div className="max-w-[860px] mx-auto" data-id="element-123">
        <div className="text-center mb-8" data-id="element-124">
          <h3 className="text-xl font-black text-white mb-2" data-id="element-125">
            CERO ATRASOS — Plan de 21 Días
          </h3>
          <p className="text-sm text-white/70" data-id="element-126">
            El Método 4C: Corta · Clasifica · Calendariza · Cierra
          </p>
          <p className="text-xs text-white/50 mt-2" data-id="element-127">
            Para Trabajadores con Ingresos Variables en Estados Unidos
          </p>
        </div>

        <div className="flex flex-col items-center justify-center gap-6 mt-8" data-id="element-128">
          {/* Legal Links */}
          <div className="flex items-center gap-3 text-sm" data-id="element-129">
            <button onClick={() => setActiveModal('privacy')} className="text-white/60 hover:text-white transition-colors underline underline-offset-2" data-id="element-130">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-131">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/60 hover:text-white transition-colors underline underline-offset-2" data-id="element-132">
              Términos de Servicio
            </button>
          </div>

          {/* Copyright */}
          <div className="text-center text-xs text-white/60" data-id="element-133">
            <p data-id="element-134">
              © {new Date().getFullYear()} CERO ATRASOS — Todos los derechos
              reservados.
            </p>
            <p className="mt-2" data-id="element-135">
              Producto digital — Entrega inmediata tras la compra
            </p>
          </div>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-136">
        <div className="space-y-5" data-id="element-137">
          <p data-id="element-138">
            <strong data-id="element-139">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString()}
          </p>

          <div data-id="element-140">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-141">
              1. Información que recopilamos
            </h3>
            <p data-id="element-142">
              Recopilamos información personal que usted nos proporciona
              directamente al realizar una compra, como su nombre, dirección de
              correo electrónico y detalles de pago. Los pagos son procesados de
              forma segura a través de nuestros proveedores de pago y no
              almacenamos los datos completos de su tarjeta de crédito.
            </p>
          </div>

          <div data-id="element-143">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-144">
              2. Uso de la información
            </h3>
            <p className="mb-2" data-id="element-145">Utilizamos su información para:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-146">
              <li data-id="element-147">
                Procesar sus transacciones y entregar el producto digital.
              </li>
              <li data-id="element-148">Enviar confirmaciones de compra y actualizaciones.</li>
              <li data-id="element-149">Proporcionar soporte al cliente.</li>
              <li data-id="element-150">
                Enviar correos electrónicos promocionales (si ha optado por
                recibirlos).
              </li>
            </ul>
          </div>

          <div data-id="element-151">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-152">
              3. Protección de datos
            </h3>
            <p data-id="element-153">
              Implementamos medidas de seguridad para mantener la seguridad de
              su información personal. No vendemos, intercambiamos ni
              transferimos a terceros su información personal identificable.
            </p>
          </div>

          <div data-id="element-154">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-155">
              4. Cookies
            </h3>
            <p data-id="element-156">
              Utilizamos cookies para mejorar su experiencia en nuestro sitio
              web, analizar el tráfico y personalizar el contenido. Puede
              desactivar las cookies en la configuración de su navegador.
            </p>
          </div>
        </div>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" data-id="element-157">
        <div className="space-y-5" data-id="element-158">
          <p data-id="element-159">
            <strong data-id="element-160">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString()}
          </p>

          <div data-id="element-161">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-162">
              1. Aceptación de los términos
            </h3>
            <p data-id="element-163">
              Al acceder y comprar en este sitio web, usted acepta estar sujeto
              a estos Términos de Servicio y a todas las leyes y regulaciones
              aplicables.
            </p>
          </div>

          <div data-id="element-164">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-165">
              2. Producto Digital
            </h3>
            <p data-id="element-166">
              El producto "CERO ATRASOS — Plan de 21 Días" es un producto
              digital (eBook). Tras la compra exitosa, recibirá acceso inmediato
              para descargar el contenido. No se enviará ningún producto físico.
            </p>
          </div>

          <div data-id="element-167">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-168">
              3. Propiedad Intelectual
            </h3>
            <p data-id="element-169">
              Todo el contenido incluido en este producto digital está protegido
              por derechos de autor. La compra le otorga una licencia personal,
              no exclusiva y no transferible para usar el material.{' '}
              <strong className="text-brand-statusRed" data-id="element-170">
                Está estrictamente prohibido revender, distribuir, copiar o
                compartir el contenido con terceros.
              </strong>
            </p>
          </div>

          <div data-id="element-171">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-172">
              4. Política de Reembolso
            </h3>
            <p data-id="element-173">
              Ofrecemos una garantía de devolución de dinero de 30 días. Si no
              está satisfecho con el producto, puede solicitar un reembolso
              completo dentro de los 30 días posteriores a la compra contactando
              a nuestro equipo de soporte.
            </p>
          </div>

          <div data-id="element-174">
            <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-175">
              5. Limitación de Responsabilidad
            </h3>
            <p data-id="element-176">
              La información proporcionada en este eBook es solo para fines
              educativos e informativos. No constituye asesoramiento financiero,
              legal o profesional. Los resultados pueden variar según la
              situación individual de cada persona.
            </p>
          </div>
        </div>
      </LegalModal>
    </footer>;
}